import { baseService } from "./base";

export const vistarService = {
  getAllVistarAccounts() {
    return baseService.get("/api/vistar-accounts");
  },

  getVistarAccountNetworks() {
    return baseService.get("/api/vistar-account/networks");
  },

  getVistarVenues(networkId: number) {
    return baseService.get(`/api/network/${networkId}/vistar-venues`);
  },
};

export default vistarService;
